"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var mobx_1 = require("mobx");
var classnames_1 = require("classnames");
var react_lazyload_1 = require("react-lazyload");
var mobx_react_1 = require("mobx-react");
var tyrande_1 = require("tyrande");
var WithEZSpm_1 = require("../../../components/WithEZSpm");
var url_1 = require("../../../utils/url");
var website_1 = require("../../../utils/website");
var ProductCardLT_1 = require("./ProductCardLT");
var ProductCardMini_1 = require("./ProductCardMini");
var utils_1 = require("./ProductCardMini/utils");
var SwipeProduct_1 = require("./SwipeProduct");
var ProductTags_1 = require("./ProductTags");
var ScrollLoad_1 = require("../../common/ScrollLoad");
var ssrcontext_1 = require("../../../ssrcontext");
var common_1 = require("services/page/common");
var tool_1 = require("mobile/utils/tool");
var tool_2 = require("mobile/utils/tool");
var index_1 = require("pc/components/Loading/index");
var store_1 = require("./store");
var styles = require("./index.scss");
var ProductsWrap = (function (_super) {
    __extends(ProductsWrap, _super);
    function ProductsWrap(props) {
        var _this = _super.call(this, props) || this;
        _this.hasListener = false;
        _this.onTagsChange = function (category, index, fixed) {
            var _a = _this.props, layout = _a.layout, id = _a.id;
            var _b = _this.productStore, loadProductsList = _b.loadProductsList, productsListMap = _b.productsListMap;
            if (category.poolId && !productsListMap[category.poolId]) {
                loadProductsList(category.poolId, layout.interaction === common_1.ModuleInteraction.RollOver);
            }
            tool_1.replaceUrl("" + id, category.name);
            _this.setState({
                activeIdx: index
            });
            if (fixed) {
                window.scrollTo(0, _this.contentRef.offsetTop - _this.props.stickToTop);
            }
        };
        _this.onLoadMoreProducts = function (poolId) { return function (isScroll) {
            _this.productStore.loadProductsList(poolId, isScroll);
        }; };
        _this.renderList = function (poolId, order, name) {
            var _a = _this.props, customUI = _a.customUI, layout = _a.layout, columnSize = _a.columnSize, spm = _a.spm, id = _a.id;
            var products = mobx_1.toJS(_this.productStore.productsListMap) && mobx_1.toJS(_this.productStore.productsListMap)[poolId];
            if (!products) {
                return null;
            }
            if (website_1.isLTMini()) {
                return (React.createElement(ProductCardMini_1.MiniProductCards, __assign({ customUI: customUI, products: products, prm: { floor: order }, spm: _this.props.spm, col: Math.max(columnSize, 5), row: layout === null || layout === void 0 ? void 0 : layout.rowNum, isSlide: utils_1.isRollOver(layout) }, utils_1.getRowColGap())));
            }
            if (layout.interaction === common_1.ModuleInteraction.RollOver) {
                return (React.createElement(SwipeProduct_1.default, { products: products, layout: layout, onClick: function (url) { return _this.linkTo(url); }, spm: spm, order: order, id: id, customUI: customUI }));
            }
            return products.map(function (item, index) {
                var link = _this.genTSpmLinkByUrl(url_1.genPrmLink(item.url, {
                    floor: id.replace("floor", ""),
                    position: index + 1
                }), order + 1, name, index + 1);
                return (React.createElement(ProductCardLT_1.ProductCardLT, { key: index, product: __assign(__assign({}, item), { url: link }), shape: customUI ? customUI.shape : undefined, type: layout.columnNum === 5 ? "small" : "normal", onClick: function () { return _this.linkTo(link); }, layout: layout }));
                return null;
            });
        };
        _this.state = {
            activeIdx: 0
        };
        _this.productStore = new store_1.default(props.pools);
        return _this;
    }
    ProductsWrap.prototype.componentDidMount = function () {
        var _a = this.props, pools = _a.pools, layout = _a.layout;
        var activeIdx = tool_2.heightLightTabIndex(pools);
        if (activeIdx > 0) {
            this.setState({
                activeIdx: activeIdx
            });
        }
        var loadProductsList = this.productStore.loadProductsList;
        var currentPool = pools[Math.max(0, activeIdx)];
        currentPool &&
            loadProductsList(currentPool.poolId, layout.interaction === common_1.ModuleInteraction.RollOver);
    };
    ProductsWrap.prototype.genTSpmLinkByUrl = function (url, order, name, productOrder) {
        var _a = this.props.spm, site = _a.site, pageId = _a.pageId, activityId = _a.activityId, componentType = _a.componentType, index = _a.index;
        var isProductWithTag = componentType === tyrande_1.ComponentType.ProductWithTag;
        var params = {
            site: site,
            activityId: activityId,
            pageId: pageId,
            channel: index,
            channelContent: {
                type: componentType,
                order: isProductWithTag ? order : "00",
                content: isProductWithTag ? name : "00",
                productOrder: productOrder
            }
        };
        return tyrande_1.genSpmLink(__assign(__assign({}, params), { url: url }), false);
    };
    ProductsWrap.prototype.linkTo = function (link) {
        tyrande_1.sendEzspmByLink(link, false);
    };
    ProductsWrap.prototype.render = function () {
        var _a;
        var _this = this;
        var _b = this.props, pools = _b.pools, customUI = _b.customUI, stickToTop = _b.stickToTop, layout = _b.layout;
        var currentPool = pools[this.state.activeIdx];
        var poolName = currentPool.name;
        var poolId = currentPool && currentPool.poolId;
        var loading = poolId ? this.productStore.isLoadingProducts[poolId] : false;
        return (React.createElement("div", { className: classnames_1.default(styles.products, (_a = {}, _a[styles.adorProducts] = false, _a)), ref: function (e) { return (_this.contentRef = e); } },
            pools.length > 1 && (React.createElement(ProductTags_1.default, { selectedIndex: this.state.activeIdx, categories: pools, customUI: customUI, stickToTop: stickToTop, onChange: this.onTagsChange })),
            layout.interaction === common_1.ModuleInteraction.None && (React.createElement(ScrollLoad_1.default, { onLoadMore: this.onLoadMoreProducts(poolId) },
                React.createElement("div", { className: styles.productContent }, this.renderList(poolId, Number(this.state.activeIdx), poolName)),
                loading && React.createElement(index_1.default, null))),
            layout.interaction === common_1.ModuleInteraction.RollOver &&
                this.renderList(poolId, Number(this.state.activeIdx), poolName)));
    };
    ProductsWrap.defaultProps = {
        columnSize: 4,
        stickToTop: 0
    };
    ProductsWrap = __decorate([
        mobx_react_1.observer
    ], ProductsWrap);
    return ProductsWrap;
}(React.Component));
exports.default = WithEZSpm_1.default(function ProductExposed(props) {
    return (React.createElement("div", { id: props.id, "data-i": props.positionIndex }, ssrcontext_1.runInServer() && +props.positionIndex < 3 ? (React.createElement(ProductsWrap, __assign({}, props))) : (React.createElement(react_lazyload_1.default, { offset: 100, height: ssrcontext_1.runInServer() ? 100 : window.innerHeight },
        React.createElement(ProductsWrap, __assign({}, props))))));
});
